<script setup>
import { useAuth } from "@okta/okta-vue";
import { onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";

const { auth } = useAuth();

const onAuthRequired = async () => {
  let oktaAuth = auth;
  const router = useRouter();
  const route = useRoute();
  await router.isReady();

  if (
    auth &&
    (auth.authStateManager.getAuthState() === null ||
      !auth.authStateManager.getAuthState().isAuthenticated) &&
    route.path != "/login/callback"
  ) {
    // App initialization stage
    await oktaAuth
      .signInWithRedirect({ originalUri: route.path })
      .then((res) => console.log(res));
  }
};

onMounted(() => {
  document.title = "FIG Bridge";
  onAuthRequired();
});
</script>

<template>
  <title>FIG Bridge</title>
  <router-view></router-view>
</template>

<style scoped>
.platform-title {
  font-family: Mark Pro;
  font-weight: 700;
  padding-left: 10px;
  font-size: 20px;
  color: #666666;
}
.header {
  overflow: hidden;
  background-color: #007873;
  height: 162px;
  position: relative;
}

.header-image {
  padding-right: 15px;
}

.header-title {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 50px;
  font-family: Mark Pro;
  font-weight: 700;
  color: white;
  padding: 10px;
  position: relative;
  z-index: 1;
}
.bg-image {
  width: auto;
  height: 163px;
  margin-right: 10px;
  position: absolute;
  top: 97%;
  transform: translateY(-50%);
  z-index: -1;
}

.bg-image-right {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 1000px;
  height: 240px;
  z-index: -1;
}

.card {
  /* Add shadows to create the "card" effect */
  position: relative;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  width: 440px;
  height: 250px;
  padding: 10px;
  margin: 10px;
}
.card-text {
  font-size: 17px;
  font-weight: 400;
  color: #cbcece;
}
.card-link {
  text-decoration: none;
  color: inherit;
}

.card-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.title {
  font-size: 21px;
  font-weight: 700;
}
.search-bar {
  position: relative;
  display: block;
  margin: 0 auto;
  width: 847px;
  height: 48px;
  font-size: 18px;
  z-index: 1;
}
.search-bar::container {
  display: flex;
  align-items: center;
  position: relative;
}
.search-bar::placeholder {
  padding: 15px;
}
.owner-label {
  font-weight: 700;
  color: #cbcece;
}
.owner-text {
  position: absolute;
  bottom: 10px;
  left: 10px;
  padding-bottom: 5px;
  padding-left: 20px;
  font-size: 17px;
  color: #cbcece;
}
.search-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}
.logo {
  margin-left: auto;
  margin-right: auto;
  display: block;
  width: 50%;
  height: 50%;
  margin: 10px;
}

.logo-icon {
  width: 100;
  height: 100;
}

.logo-head {
  padding-left: 10px;
}

/* On mouse-over, add a deeper shadow */
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  outline: 1px solid black;
}
.card:hover .card-text {
  color: black !important;
}

.card:hover .owner-label {
  color: black !important;
}

.card:hover .owner-text {
  color: black !important;
}
/* Add some padding inside the card container */
.container {
  padding: 2px 16px;
}

@media screen and (max-width: 500px) {
  .header-title {
    float: none;
  }
}
</style>
